import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshAccount = useCallback(async () => {
    try {
      const { data } = await api.get("/account");
      setAccount(data);
    } catch {}
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("cs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setAccount(data.account);
      })
      .catch(() => localStorage.removeItem("cs_token"))
      .finally(() => setLoading(false));
  }, []);

  const applyAuth = (data) => {
    localStorage.setItem("cs_token", data.token);
    setUser(data.user);
    setAccount(data.account);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applyAuth(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    applyAuth(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("cs_token");
    setUser(null);
    setAccount(null);
  };

  return (
    <AuthContext.Provider value={{ user, account, setAccount, loading, login, register, logout, refreshAccount }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
